<template>
    <div>
        <b-tabs type="is-boxed">
            <b-tab-item>
                <template slot="header">
                    <b-icon pack="fas" icon="file-signature"></b-icon>
                    <span> {{ $t('permitting') }} </span>
                </template>
                <div>
                    <div class="flex flex-row justify-end mb-2">
                        <v-button @click="handleAddPermitting" class="mt-3" icon="add">
                            {{ $t('add') }} {{ $t('permitting') }}
                        </v-button>
                    </div>
                    <permittingsTable ref="permittings_table" :project-id="projectId"
                        @edit-permitting="handleAddPermitting" @remove-permitting="handleSuccess" />
                    <permittingModal ref="permitting_modal" :project-id="projectId" :modal-ref="$refs.permitting_modal"
                        @reload-list="handleSuccess"  :loading-activities="loadingActivities" />
                </div>
            </b-tab-item>


        </b-tabs>

    </div>
</template>

<script>
import PermittingsTable from './permittings-table.vue';
import PermittingModal from './permitting-modal.vue';
import axios from 'axios';
export default {
    props: {
        projectId: {
            type: Number,
            required: true
        },
        company: {
            type: Number,
            required: true
        }
    },
    components: {
        PermittingsTable,
        PermittingModal,
    },
    data() {
        return {
            activities: [],
            templates: [],
            loadingActivities: false,
        }
    },
    mounted() {
        this.getActivities();
        this.getPermittingTemplate();
    },
    methods: {
        handleAddPermitting(permitting = null) {
            this.openPermittingModal(permitting)
        },
        handleReload() {
            this.getPermittingTemplate();
        },
      async openPermittingModal(permitting) {
            if (this.loadingActivities) return; // evita abrir si está cargando
            if (!this.activities.length) {
                await this.getActivities();
            }
            this.$refs.permitting_modal.show(permitting, this.activities, this.templates);
        },
        async getActivities() {
            try {
                const response = await axios.get(`/api/v2/activities`, {
                    params: {
                        p: this.projectId,
                        light: 1,
                        s: 1,
                        per_page: 999,
                        skip_map: 1
                    }
                });
                // Solo actividades principales y subactividades (2 niveles)
                this.activities = response.data.activities
                    .filter(activity => activity.parent_id === null)
                    .map(activity => ({
                        id: activity.id,
                        label: activity.name,
                        current_start_date: activity.current_start_date,
                        children: (activity.subactivities || []).map(sub => ({
                            id: sub.id,
                            label: sub.name,
                            current_start_date: sub.current_start_date,
                            isLeaf: true
                        })),
                        isLeaf: !(activity.subactivities && activity.subactivities.length)
                    }));
            } catch (error) {
                throw ("Error cargando actividades", error);
            }
             finally {
        this.loadingActivities = false;
    }
        },


       async getPermittingTemplate() {
            try {
                const {data} = await axios.get(`/api/v2/company/${this.company}/project/${this.projectId}/permitting-templates`);
                this.templates = Array.isArray(data) ? data : [];
            } catch (error) {
                throw (error);
            }
        },
        handleSuccess() {
            this.$refs.permittings_table.getPermittings()
            this.getPermittingTemplate();
        },

    },
}
</script>

<style lang="scss" scoped></style>